import React, { FC } from 'react';

interface Props {
  readonly progressPercentage: number;
}

const ProgressBar: FC<Props> = ({ progressPercentage }: Props) => {
  const progress = progressPercentage >= 100 ? 100 : progressPercentage;
  return (
    <div className="h-3  rounded-full w-full bg-light-blue-dark">
      <div
        style={{ width: `${progress}%`, transition: 'width 0.5s' }}
        className={`h-full rounded-full ${
          progress <= 99 ? 'bg-french-blue' : 'bg-check-green'
        }`}
      />
    </div>
  );
};

export default ProgressBar;
